/* app/js/src/components/channel/first-timer/first-timer.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
}
header {
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
  height: 12px;
  line-height: 12px;
  padding: 20px 37px;
}
main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
main .first-half {
  background-color: #40c4ff;
  display: flex;
  color: #ffffff;
  flex-direction: column;
  align-items: center;
  flex-basis: 50%;
  position: relative;
}
main .first-half .main-header {
  padding-top: 71px;
  font-size: 32px;
  font-weight: bold;
}
main .first-half .second-header {
  font-size: 24px;
  margin: 8px 0;
}
main .plus-sign {
  width: 76px;
  height: 76px;
  background-color: #ffffff;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -37px;
  cursor: pointer;
}
main .second-half {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #879baf;
  background-color: #eef2f6;
  flex-basis: 50%;
}
main .second-half .content {
  padding-top: 62px;
}
main .second-half a {
  position: relative;
  left: -38px;
}
.cubes {
  position: absolute;
  width: 21px;
  height: 21px;
  background-size: contain;
  background-repeat: no-repeat;
}
.cube-1 {
  top: 30px;
  left: 482px;
  background-image: url(/assets/cube-0-2@2x.png);
}
.cube-2 {
  top: 77px;
  left: 440px;
  background-image: url(/assets/cube-0-3@2x.png);
}
.cube-3 {
  top: 143px;
  left: 256px;
  background-image: url(/assets/cube-0-2@2x.png);
}
.cube-4 {
  bottom: 51px;
  left: 411px;
  background-image: url(/assets/cube-0-2@2x.png);
}
.cube-5 {
  top: 111px;
  right: 419px;
  background-image: url(/assets/cube-0-2@2x.png);
}
.cube-6 {
  top: 154px;
  right: 218px;
  background-image: url(/assets/cube-01-copy@2x.png);
}
.cube-7 {
  bottom: 54px;
  right: 389px;
  background-image: url(/assets/cube-0-1@2x.png);
}
/*# sourceMappingURL=first-timer.css.map */
